import classNames from "classnames";
import React from "react";
import { config } from "@fidget/common/config/config";
import { getWheelhouseDownloadUrl } from "@fidget/common/utils/urlMappingHelpers";
import { intl } from "../../i18n/TypedIntl";
import { isAgentProfile, UserProfile } from "../../models/userProfile";
import { UserPresenter } from "../../utils/userPresenter";
import { ImageComponent } from "../image/image";
import styles from "./avatar.css";
import { DefaultAgentAvatar } from "./defaultAgentAvatar";
import { InitialsAvatar } from "./initialsAvatar";

interface Props {
  user?: UserProfile;
  widgetStyle?: boolean;
  agent?: AvatarAgent;
}

interface AvatarAgent {
  isBot: boolean;
  avatarToken?: string;
}

export const Avatar = ({ user, widgetStyle, agent }: Props) => {
  const keanu = `https://placekeanu.com/${
    300 + (user && user.firstName ? user.firstName.length : Math.floor(Math.random() * 50))
  }/300`;

  const fallback =
    config.services.env === "development" ? (
      <ImageComponent
        src={keanu}
        fallbackComponent={<DefaultAgentAvatar widgetStyle={widgetStyle} />}
      />
    ) : (
      <DefaultAgentAvatar widgetStyle={widgetStyle} />
    );

  const avatar = (isBot: boolean, avatarToken?: string) => {
    if (isBot && !avatarToken) {
      return (
        <div className={classNames(styles["lekta-avatar"], { [styles.dashboard]: !widgetStyle })} />
      );
    }
    return <ImageComponent src={avatarToken && getWheelhouseDownloadUrl(avatarToken)} fallbackComponent={fallback} />;
  };

  if (agent) {
    return avatar(agent.isBot, agent.avatarToken);
  } else if (user && isAgentProfile(user)) {
    return avatar(user.isBot, user.avatarToken);
  } else {
    return (
      <InitialsAvatar
        name={
          user
            ? UserPresenter.from(user).displayedName
            : intl.formatMessage("user.displayedName.undefined")
        }
      />
    );
  }
};
